/*
 * Starts slow autoplay on the related-products carousel.
 *
 * The app builds its Swiper after window load, so the instance is polled for
 * rather than looked up once. Autoplay is configured on the live instance
 * because the app owns the initialisation and we cannot pass options into it.
 */
(() => {
  const SELECTOR = '.recomatic-container';
  const DELAY = 3000;
  const SPEED = 900;
  const TIMEOUT = 20000;
  const INTERVAL = 300;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const started = new WeakSet();

  const start = (element) => {
    const swiper = element.swiper;
    if (!swiper || started.has(element)) return Boolean(swiper);

    // Nothing to rotate through if every slide already fits.
    const perView = swiper.params?.slidesPerView;
    if (typeof perView === 'number' && swiper.slides?.length <= perView) {
      started.add(element);
      return true;
    }

    swiper.params.speed = SPEED;
    swiper.params.autoplay = {
      delay: DELAY,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };

    swiper.autoplay?.start?.();
    started.add(element);
    return true;
  };

  /*
   * The app renders its headline as an <h2>, which competes with the product
   * page's own headings. Swapping the tag keeps the outline sensible; it has
   * to happen here because the markup comes from the app block.
   */
  const demoteHeadline = () => {
    document.querySelectorAll('h2.recomatic-headline').forEach((heading) => {
      const replacement = document.createElement('h4');
      replacement.className = heading.className;
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  };

  const poll = () => {
    demoteHeadline();

    const elements = document.querySelectorAll(SELECTOR);

    if (elements.length > 0) {
      let allStarted = true;
      elements.forEach((element) => {
        if (!start(element)) allStarted = false;
      });
      if (allStarted) return;
    }

    if (Date.now() - begin > TIMEOUT) return;
    setTimeout(poll, INTERVAL);
  };

  const begin = Date.now();
  poll();
})();
